module.exports = __webpack_public_path__ + "static/media/login-shape-secondary.ad329308.png";